import { MoveConnectorCommand, RouteEndpointChange } from "./MoveConnectorCommand";
import type { CommandContext } from "../types";

/**
 * Command for "Disconnect stages": splits a shared stage-connector point
 * into two side-by-side endpoint markers (the geometry changes are plain
 * connector-style endpoint moves) AND flags the pair in
 * state.disconnectedStageIds so it doesn't immediately auto-reconnect.
 * Undo restores both routes and re-connects the pair.
 */
export class DisconnectStagesCommand extends MoveConnectorCommand {
  readonly type: string = 'DISCONNECT_STAGES';

  constructor(changes: RouteEndpointChange[], private connectorId: string) {
    super(changes);
  }

  undo(ctx: CommandContext): void {
    super.undo(ctx);
    ctx.state.disconnectedStageIds =
      ctx.state.disconnectedStageIds.filter(id => id !== this.connectorId);
  }

  redo(ctx: CommandContext): void {
    super.redo(ctx);
    if (!ctx.state.disconnectedStageIds.includes(this.connectorId)) {
      ctx.state.disconnectedStageIds.push(this.connectorId);
    }
  }
}
